// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const safe = (obj: any, ...properties: any[]): any =>
  obj && properties.reduce((p, prop) => p?.[prop], obj)
